import { attr, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import DiscountSummary from './DiscountSummary';

const Reward = ApplicationRecord.extend({
  attrs: {
    banner_subtext: attr(),
    banner_title: attr(),
    code: attr(),
    customer_id: attr(),
    discount_summaries: hasMany({ type: DiscountSummary }),
    discount_type: attr(),
    expires_at: attr(),
    promotion_id: attr(),
    redemption_id: attr(),
    state: attr(),
    subscription_meal_count_at_redemption: attr(),
    subscription_meal_count_per_delivery: attr(),
    voucher_code: attr(),
  },
  static: {
    endpoint: '/rewards',
    jsonapiType: 'vouchers-rewards',
  },
});

export default Reward;
